import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import LeadPhoneCall, {leadPhoneCallSizes, leadPhoneCallTarget} from '@adv-mt/mt-lead-phone-call'
import IconMail from '@adv-mt/mt-svg-icons/lib/MailOutline'

import {NO_OP} from '../config.js'
import ActionButtons from './ActionButtons.js'

const baseClass = 'mt-HeroDealer-buttons'

const ContactButtons = ({
  adId,
  dealer,
  extendedLeadTrackingData,
  isHidePhone,
  isLoggedUser,
  isFavorite,
  isShareDealerEnabled,
  multiProvinceTrackingData,
  onClickOpenModal = NO_OP,
  pageName
}) => {
  const {i18n} = useContext(Context)

  const {hasCallTrackingService, isActive, id, phoneNumber} = dealer

  return (
    <div className={baseClass}>
      {isActive && (
        <AtomButton
          color={atomButtonColors.ACCENT}
          design={atomButtonDesigns.SOLID}
          leftIcon={<IconMail />}
          onClick={() => onClickOpenModal(true)}
          shape={atomButtonShapes.CIRCULAR}
        >
          {i18n.t('COMMON_CONTACT')}
        </AtomButton>
      )}
      {isActive && !isHidePhone && (
        <LeadPhoneCall
          adId={adId}
          color={atomButtonColors.ACCENT}
          contractId={id}
          extendedLeadTrackingData={extendedLeadTrackingData}
          hasCallTrackingService={hasCallTrackingService}
          isLoggedUser={isLoggedUser}
          pageName={pageName}
          phone={phoneNumber}
          size={leadPhoneCallSizes.medium}
          target={adId ? leadPhoneCallTarget.vehicle : leadPhoneCallTarget.dealerHeader}
          multiprovince={multiProvinceTrackingData}
          isFullWidth={false}
        />
      )}
      <ActionButtons
        dealer={dealer}
        isFavorite={isFavorite}
        isShareDealerEnabled={isShareDealerEnabled}
        className={`${baseClass}-action`}
      />
    </div>
  )
}

ContactButtons.propTypes = {
  adId: PropTypes.string,
  dealer: PropTypes.object,
  extendedLeadTrackingData: PropTypes.object,
  isHidePhone: PropTypes.bool,
  isLoggedUser: PropTypes.bool,
  isFavorite: PropTypes.bool,
  isShareDealerEnabled: PropTypes.bool,
  multiProvinceTrackingData: PropTypes.object,
  onClickOpenModal: PropTypes.func,
  pageName: PropTypes.string
}

export default ContactButtons
